// common
import clsx from 'clsx';
import { Tooltip } from 'react-tooltip';

// components
import Button from '../button';

// styles
import styles from './style';

// Props Interface
interface Props {
  className?: any;
  dots?: boolean;
  borderless?: any;
  bordered?: any;
  style?: any;
  buttonContainerStyle?: any;
  width?: number;
  color?: string;
  marginHorizontal?: number;
  marginVertical?: number;
  textClassName?: string;
  selectedTextClassName?: string;
  tabClassName?: string;
  selectedClassName?: string;
  selectedTextColor?: string;
  options: any;
  selected: any;
  onSelect: any;
  singleLine?: boolean;
  tooltipWidth?: number;
  tooltip?: React.ReactNode;
}

const RadioButton: React.FunctionComponent<Props> = (props) => {
  let className = clsx(
    'flex flex-row justify-center text-center items-center',
    `${props.className}`,
  );

  const color = props.color
    ? { borderBottomColor: props.color }
    : { borderBottomColor: '#f4f4f4' };
  const marginHorizontal = props.marginHorizontal
    ? { marginHorizontal: props.marginHorizontal }
    : null;
  const marginVertical = props.marginVertical
    ? { marginVertical: props.marginVertical }
    : null;
  const bordered = props.bordered ? props.bordered : true;

  return (
    <div
      className={className}
      style={{
        ...styles.divider,
        ...color,
        ...marginHorizontal,
        ...marginVertical,
        ...props.style,
      }}
    >
      {props.options.map(
        (
          element: {
            name: string;
            value: any;
            isHidden: boolean;
            tooltip?: React.ReactNode;
          },
          index,
        ) => {
          if (element.isHidden) {
            return null;
          }

          const isSelected =
            props?.selected == element.value ||
            props?.selected?.value == element.value;
          const activeColor = props.selectedTextColor;
          const textColor = isSelected ? 'black' : 'black';
          let borderColor = isSelected ? 'black' : '#E8E8E8';
          if (props.borderless) {
            borderColor = 'transparent';
          }
          const getSelectedTextColor = () => {
            if (isSelected && activeColor) {
              return activeColor;
            }

            return textColor;
          };

          const buttonContent = (
            <Button
              key={`radioButton${index}`}
              bordered={props.borderless ? undefined : bordered}
              style={{ flex: 1 }}
              text={element.name}
              justify={'center'}
              className={`${
                isSelected ? props.selectedClassName : props.tabClassName
              }`}
              textClassName={`${
                isSelected ? props.selectedTextClassName : props.textClassName
              }`}
              textColor={getSelectedTextColor()}
              borderColor={
                props.selectedClassName || props.tabClassName
                  ? null
                  : borderColor
              }
              onClick={() => {
                props.onSelect(element);
              }}
            />
          );

          return (
            <div
              key={index}
              className={`flex flex-row w-full items-center ${
                props.singleLine ? 'whitespace-nowrap' : ''
              }`}
              style={props.buttonContainerStyle}
            >
              {props.dots ? (
                <div
                  className={`rounded-full w-2 h-2 bg-black mr-1 ${
                    isSelected ? '' : 'opacity-30'
                  }`}
                />
              ) : null}

              {element.tooltip ? (
                <div data-tooltip-id={`tooltip-${index}`}>{buttonContent}</div>
              ) : (
                buttonContent
              )}

              {element.tooltip && (
                <Tooltip
                  id={`tooltip-${index}`}
                  style={{
                    ...(props.tooltipWidth
                      ? {
                          width: `${props.tooltipWidth}px`,
                          maxWidth: `${props.tooltipWidth}px`,
                        }
                      : {}),
                    justifyContent: 'flex-start',
                    textAlign: 'start',
                  }}
                >
                  {element.tooltip}
                </Tooltip>
              )}
            </div>
          );
        },
      )}
    </div>
  );
};

export default RadioButton;
